<template>
  <v-layout row wrap>
    <v-flex>

      <v-slide-y-transition mode="out-in">
        <v-container fluid class="pa-3">
          <v-layout row wrap>
            <v-flex>
              <v-card>
                <v-toolbar dense prominent>
                  <v-toolbar-title>Application Log Listing</v-toolbar-title>
                  <v-spacer></v-spacer>

                  <v-toolbar-items> </v-toolbar-items>
                </v-toolbar>

                <v-card-text class="pa-0">
                  <v-container>
                    <v-layout row wrap>
                      <v-expansion-panel>
                        <v-expansion-panel-content class="accent">
                          <template v-slot:header>
                            <div class="subheading">
                              Filter Panel
                            </div>
                          </template>

                          <v-btn color="green" @click="refreshData()"
                            >Generate Now</v-btn
                          >

                          <FilterEditor
                            :query.sync="new_filter"
                            :rules="get_filterable_columns"
                            class="accent"
                          />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-data-table
                          :headers="table_setting.headers"
                          :items="table_setting.records"
                          :loading="table_setting.loading"
                          must-sort
                          :pagination.sync="table_setting.pagination"
                          :rows-per-page-items="table_setting.rows_per_page_items"
                          :total-items="table_setting.pagination.totalItems"
                          class="elevation-1"
                        >
                          <v-progress-linear
                            color="blue"
                            indeterminate
                          >
                            <template v-slot:progress>
                            </template>
                          </v-progress-linear>
                          <template v-slot:items="props">
                            <td class="pa-1 pl-3">{{ props.item.id }}</td>
                            <td class="pa-1">{{ convert_2_locale_datetime(props.item.created_date) }}</td>
                            <td class="pa-1">{{ props.item.created_by__username }}</td>
                            <!-- <td class="pa-1">{{ props.item.created_by__user__full_name }}</td> -->
                            <td class="pa-1">{{ props.item.table_name }}</td>
                            <td class="pa-1">{{ props.item.event_type }}</td>
                            <td class="pa-1">
                              <pre>{{ props.item.content }}</pre>
                            </td>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-slide-y-transition>

    </v-flex>
  </v-layout>
</template>

<script>
import common from "../../functions/general";
import qb from "../../functions/query.builder";
import FilterEditor from "../../components/FilterEditor";

export default {
  name: "CompanyListingPage",
  components: {
    FilterEditor: FilterEditor
  },
  data() {
    return {
      new_filter: {
        condition: "and",
        rules: []
      },
      table_setting: {
        loading: false,
        rows_per_page_items: [10, 40, 70, 100],
        headers: [
          {
            text: "ID#",
            value: "id",
            class: "pa-1 pl-3",
            filterable: true,
            data_type: Number
          },
          {
            text: "Modified Datetime",
            class: "pa-1",
            value: "created_date",
            filterable: true,
            data_type: Number
          },
          {
            text: "Modified By",
            class: "pa-1",
            value: "created_by__username",
            // value: "created_by__user__full_name",
            filterable: true,
            data_type: String
          },
          {
            text: "Source",
            class: "pa-1",
            value: "table_name",
            filterable: true,
            data_type: String
          },
          {
            text: "Event Tpe",
            class: "pa-1",
            value: "event_type",
            filterable: true,
            data_type: String
          },
          {
            text: "Content",
            class: "pa-1",
            value: "content",
            filterable: true,
            data_type: String
          }
        ],
        records: [],
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 10,
          sortBy: "id",
          totalItems: 0
        }
      }
    };
  },
  computed: {
    get_filterable_columns() {
      var return_value = this.table_setting.headers.filter(
        rec => rec.filterable == true
      );
      return return_value;
    }
  },
  watch: {
    "table_setting.pagination": {
      handler: function() {
        this.refreshData();
      },
      deep: true
    }
  },
  async mounted() {
  },
  methods: {
    convert_2_locale_datetime(date) {
      return common.App.to_locale_datetime(date);
    },
    async refreshData() {
      let cls_qb = new qb.QueryBuilder();

      cls_qb.Method = "all";

      cls_qb.Select = [
        "id",
        "created_date",
        "created_by__username",
        // "created_by__user__full_name",
        "table_name",
        "event_type",
        "content"
      ];

      cls_qb.Where = this.new_filter;

      if (this.table_setting.pagination.rowsPerPage > 0) {
        cls_qb.Offset =
          (this.table_setting.pagination.page - 1) *
          this.table_setting.pagination.rowsPerPage;
        cls_qb.Limit = this.table_setting.pagination.rowsPerPage;
      }

      cls_qb.Order = [
        this.table_setting.pagination.descending
          ? "-" + this.table_setting.pagination.sortBy
          : this.table_setting.pagination.sortBy
      ];

      let result = await common.wBackEndComm.PostData("log/listing/", cls_qb);

      if (result.data.Status == 1) {
        this.table_setting.records = result.data.Body.records;

        this.table_setting.pagination.totalItems =
          result.data.Body.total_records_after_filtered;

      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    }
  }
};
</script>

<style>
</style>
